<template>
    <b-modal id="modal-change-payment-method"
             hide-footer
             centered
             v-model="isVisible"
             :title="$t('cdb.subscriptions.adjust_payment_methode')"
    >
        <div class="row" v-if="isDefaultMode">
            <div class="cols-12 px-4">
                <b-form-radio
                    class="stripe-payment-methods"
                    v-for="pm in paymentMethods"
                    :key="pm.key"
                    :value="pm"
                    name="payment-method"
                    v-model="selectedPaymentMethod"
                >
                    <component
                        v-bind:is="getPaymentComponent"
                        :selected-payment-method="pm"
                    ></component>
                </b-form-radio>
            </div>
            <div class="cols-12 px-4 pt-4">
                <button type="button" class="btn btn-outline-primary" @click="showAddPaymentMethod">{{ $t('cdb.subscriptions.new_payment_methode') }}</button>
            </div>
        </div>

        <div class="row" v-if="isAddMode">
            <div class="col-12">
                <strong>{{ $t('co.payment_methods.new.title') }}</strong>

                <div class="mt-3" id="stripe-payment-element"></div>
            </div>
        </div>

<!--        footer-->
        <div class="row pt-3 d-flex justify-content-end" v-if="isDefaultMode">
           <button type="button" class="btn btn-secondary mr-3" @click="abort">{{ $t('cdb.subscriptions.abort') }}</button>
           <button type="button" class="btn btn-primary mr-3" @click="update">{{ $t('cdb.subscriptions.change_payment_methode') }}</button>
        </div>

        <b-row class="pt-3 d-flex justify-content-end" v-if="isAddMode">
            <button type="button" class="btn btn-secondary mr-3" @click="changeMode('default')" v-if="!isSubmitting">{{ $t('cdb.subscriptions.abort') }}</button>
            <button type="button" class="btn btn-primary mr-3" @click="updateStripe" v-if="!isSubmitting">{{ $t('cdb.subscriptions.save') }}</button>
            <button type="button" class="btn btn-primary mr-3 disabled" v-if="isSubmitting">{{ $t('cdb.subscriptions.loading') }}</button>
        </b-row>
    </b-modal>
</template>

<script>
import { EventBus } from '../../event-bus';
import {
    BModal, BFormRadio, BFormRadioGroup
} from 'bootstrap-vue';
import StripeCardInfo from "../atoms/StripeCardInfo.vue";
import StripeSepaInfo from "../atoms/StripeSepaInfo.vue";
import UpdatePaymentMethod from "./UpdatePaymentMethod.vue";

export default {
    name: 'ModalChangePaymentMethods',
    components: {
        UpdatePaymentMethod,
        StripeCardInfo, StripeSepaInfo,
        BModal,
        BFormRadio, BFormRadioGroup,
    },
    data() {
        return {
            isRendered: false,
            isVisible: false,
            isSubmitting: false,
            subscription: null,
            paymentMethods: null,
            selectedPaymentMethod: null,
            mode: 'default',
            method: 1,
            stripe: {
                instance: null,
                elements: null,
                paymentElement: null,
                appearance: {}, // https://stripe.com/docs/stripe-js/appearance-api
                error: null
            }
        }
    },
    methods: {
        initStripe: function () {
            this.$stripe.loadStripe(this.$root.whitelabel)
        },
        getData(data) {
            this.isVisible = true

            this.$root.stripe.overwriteStripeSettings(data.subscriptionData.stripe_key, data.subscriptionData.payment_flow_type)

            this.subscription = data.subscriptionData
            this.paymentMethods = data.paymentMethods
            this.selectedPaymentMethod = data.selectedPaymentMethod
        },
        abort(){
            this.isVisible = false
        },
        update(){
            this.$axios.put('api/v1/checkout/update_subscription', {
                subscription_uuid: this.subscription.uuid,
                stripe_source: this.selectedPaymentMethod.id
            }).then(response => {
                this.isVisible = false
                EventBus.$emit('cdb-reload-subscriptions')
            })
        },
        changeMode(mode){
            this.mode = mode
        },
        showAddPaymentMethod() {
            this.mode = 'add'
            let methods = ['card']
            if(this.$root.whitelabel.setting('show_sepa')) {
                methods.push('sepa_debit')
            }

            this.$axios.post('api/v1/payment_methods/create_setup_intent', {
                subscription_uuid: this.subscription.uuid,
                paymentMethods: methods
            }).then(response => {
                const data = this.$root.stripe.getStripeData()
                this.stripe.instance = data.stripe
                this.stripe.elements = this.stripe.instance.elements({
                    clientSecret: response.data.setupIntent.client_secret,
                    appearance: this.stripe.appearance
                })
                // this.stripeStyles = data.styles
                this.stripe.paymentElement = this.stripe.elements.create('payment')
                this.stripe.paymentElement.mount('#stripe-payment-element')
                this.isRendered = true
            }).catch(error => {
                this.stripe.error = error.message
            })
        },
        updateStripe() {
            // Handles the submit of the Stripe payment element form
            const getUrl = window.location;
            const baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
            const callbackUrl = baseUrl + "api/v1/stripe/verify-payment-method" + "?uuid=" + this.subscription.uuid
            this.isSubmitting = true

            this.stripe.instance.confirmSetup({
                elements: this.stripe.elements,
                redirect: "if_required",
                confirmParams: {
                    return_url: callbackUrl
                }
            }).then(response => {
                this.$axios.post("api/v1/payment_methods/attach", {
                    payment_method: response.setupIntent.payment_method,
                    subscription_uuid: this.subscription.uuid
                }).then(response2 => {
                    this.paymentMethods = response2.data.availablePaymentMethods
                    this.selectedPaymentMethod =  this.paymentMethods.find( pm => pm.id === response.setupIntent.payment_method );

                    this.mode = 'default'
                    this.isSubmitting = false
                }).catch(error => {
                    this.stripe.error = error.message
                    this.isSubmitting = false
                })


            }).catch(error => {
                this.isSubmitting = false
                this.stripe.error = error.message
            })
        },
    },
    computed: {
        isDefaultMode(){
            return this.mode === 'default'
        },
        isAddMode(){
            return this.mode === 'add'
        },
        getPaymentComponent(){
            switch(this.selectedPaymentMethod.type) {
                case "card":
                    return "stripe-card-info"
                case "sepa":
                    return "stripe-sepa-info"
                default:
                    return ""
            }
        }
    },
    mounted() {
        this.initStripe()
        EventBus.$on('init-change-payment-method', this.getData);
    },
}
</script>

<style lang="scss" scoped>
.stripe-payment-methods::v-deep {
    padding: 6px 16px;
}
</style>
